<section class="card p-6 mb-6">

  <div class="grid grid-cols-1 gap-6">

    <div class="col-span-3">
      <div class="flex justify-between">
          <h2 class="text-xl font-semibold">Industry landscape</h2>
          <app-edit-button *ngIf="edit" [edit]="edit"></app-edit-button>
      </div>
    </div>

    <!-- Top challenges -->
    <div class="col-span-3 xl:col-span-2">

      <div *ngIf="company?.industry">
        <h3  class="text-base font-semibold pb-3">Industry</h3>
        <div class="mb-6">
          <p>{{ company?.industry }}</p>
        </div>
      </div>

      <div *ngIf="company">
        <h3 class="text-base font-semibold pb-3">Top challenges</h3>

        <!--
        {{ company | getAssistantPrompt: 'ASK_ASSISTANT_INDUSTRY_CHALLENGES' ?? '' }}
        -->

        <app-assistant-prompt tag="ASK_ASSISTANT_INDUSTRY_CHALLENGES"
                              title="Industry Challenges"
                              [type]="'insights'"
                              [company]="company"
                              [showButton]="true"
                              [buttonType]="1"
                              [reportId]="reportSearch?.id">
        </app-assistant-prompt>

      </div>

    </div>
    <!-- / Top challenges -->

  </div>

</section>
